import styled from 'styled-components';
export const ContainerTitle = styled.h1 `
  font-weight: bold;
  color: ${({ theme }) => theme.titlePageFontColor};
  text-align: ${(props) => (props.center ? 'center' : 'left')};
  font-size: ${(props) => props.smallerFontSize ? props.theme.mdFontSize : props.theme.lgFontSize};
  @media ${(props) => props.theme.device.mobileXL} {
    font-size: 18px;
  }
  margin-bottom: ${(props) => { var _a; return (_a = props.mb) !== null && _a !== void 0 ? _a : ''; }};
  margin-right: 10px;
`;
export const ContainerSubTitle = styled.h2 `
  font-weight: bold;
  text-align: ${(props) => (props.center ? 'center' : 'left')};
  color: ${({ theme }) => theme.subTitleFontColor};
  font-size: ${(props) => props.smallerFontSize ? props.theme.mdFontSize : props.theme.lgFontSize};
  margin-bottom: ${(props) => { var _a; return (_a = props.mb) !== null && _a !== void 0 ? _a : ''; }};
`;
export const ContainerSmallerTitle = styled.h3 `
  font-weight: bold;
  text-align: ${(props) => (props.center ? 'center' : 'left')};
  color: ${({ theme }) => theme.titleFontColor};
  font-size: ${(props) => props.theme.smFontSize};
  margin-bottom: ${(props) => { var _a; return (_a = props.mb) !== null && _a !== void 0 ? _a : ''; }};
`;
